<template>
  <div class="page">
    <MainLayout>
      <main class="p-4">
        <section data-section="welcome">
          <h2 class="govgr-heading-l">Καλωσορίσατε στην Πλατφόρμα Υπολογισμού Παροχών</h2>
          <p class="govgr-!-font-size-19">
            Αυτή η πλατφόρμα σας βοηθά να δείτε εύκολα αν δικαιούστε παροχές όπως:
          </p>
          <ol class="govgr-list govgr-list--bullet govgr-!-font-size-19">
            <li>Επίδομα Παιδιού (Α21)</li>
            <li>Επίδομα Στέγασης</li>
            <li>Επίδομα Θέρμανσης</li>
            <li>Κοινωνικό Οικιακό Τιμολόγιο (ΚΟΤ)</li>
            <li>Ελάχιστο Εγγυημένο Εισόδημα (ΕΕΕ)</li>
          </ol>
          <p class="govgr-body" id="intro-box" tabindex="4">
            <strong><a href="#" @click.prevent="showDisclaimerModal = true"
                        style="text-decoration: underline; cursor: pointer; color: #003375;">Αποποίηση Ευθύνης</a>:
            </strong>Η υπηρεσία αυτή αποτελεί ερευνητικό πρωτότυπο του Πανεπιστημίου
                Μακεδονίας και δεν αποτελεί
                επίσημη υπηρεσία του <a href="http://www.gov.gr" target="_blank" style="text-decoration: underline; cursor: pointer; color: #003375;">gov.gr</a>. Παρέχεται αποκλειστικά για δοκιμαστικούς σκοπούς
                χωρίς καμία ευθύνη ή εγγύηση.
                Για επίσημες πληροφορίες, επισκεφθείτε το <a href="http://www.gov.gr" target="_blank" style="text-decoration: underline; cursor: pointer; color: #003375;">www.gov.gr</a>.<br />
          </p>
          
          <!-- Disclaimer Modal -->
          <transition name="modal">
            <div v-if="showDisclaimerModal" class="modal-overlay" @click="closeModal">
              <div class="modal-content" @click.stop role="dialog" aria-labelledby="modal-title" aria-modal="true">
                <h2 id="modal-title" class="govgr-heading-m">Αποποίηση Ευθύνης (Disclaimer)</h2>
                <div class="modal-body">
                  <p>Η παρούσα διαδικτυακή υπηρεσία αποτελεί ερευνητικό πρωτότυπο που αναπτύχθηκε από το Πανεπιστήμιο Μακεδονίας στο πλαίσιο ερευνητικών ή πιλοτικών δραστηριοτήτων. Δεν αποτελεί επίσημη υπηρεσία ή πηγή πληροφοριών της Ελληνικής Κυβέρνησης ή του gov.gr, ούτε συνδέεται ή εγκρίνεται από αυτά.</p>
                  <p>Το περιεχόμενο, τα δεδομένα και τα αποτελέσματα που παρέχονται μέσω της παρούσας υπηρεσίας είναι πειραματικού χαρακτήρα και διατίθενται «ως έχουν» (as is), χωρίς καμία ρητή ή σιωπηρή εγγύηση ακρίβειας, πληρότητας ή επικαιρότητας.</p>
                  <p>Το Πανεπιστήμιο Μακεδονίας και οι ερευνητές του έργου δεν φέρουν καμία ευθύνη ή υποχρέωση για τυχόν λάθη, παραλείψεις, ανακρίβειες, καθυστερήσεις, ή οποιαδήποτε άμεση ή έμμεση ζημία, απώλεια ή βλάβη που ενδέχεται να προκύψει από τη χρήση ή την εμπιστοσύνη στο περιεχόμενο της υπηρεσίας.</p>
                  <p>Οι επισκέπτες και χρήστες της υπηρεσίας προτρέπονται να ανατρέχουν πάντα στους επίσημους ιστότοπους της Ελληνικής Κυβέρνησης και του gov.gr για ακριβείς, επίσημες και επικαιροποιημένες πληροφορίες.</p>
                  <p><strong>Με τη χρήση της υπηρεσίας, ο επισκέπτης αποδέχεται πλήρως τους παραπάνω όρους και την αποποίηση ευθύνης.</strong></p>
                </div>
                <button class="govgr-btn govgr-btn-primary" @click="closeModal">
                  Κλείσιμο
                </button>
              </div>
            </div>
          </transition>
        </section>
        <hr class="govgr-section-break govgr-section-break--visible"/>
        <section data-section="benefits">
          <h2 class="govgr-heading-l govgr-!-font-weight-bold">Πώς Λειτουργεί η Πλατφόρμα</h2>
          <ol class="govgr-list govgr-list--number govgr-!-font-size-19 govgr-mb-6">
            <li class="govgr-mt-9 govgr-mb-6"> Μεταβείτε στην καρτέλα "Προσομοίωση" για να κάνετε μια προσομοίωση και να δείτε συνολικά για ποιές παροχές μπορεί να είστε επιλέξιμοι.</li>
              <router-link :to="assessmentLink">
                <button class="govgr-btn govgr-btn-primary govgr-btn-cta govgr-mb-12">
                    Προσομοίωση
                  <svg viewBox="0 0 24 24" 
                    class="govgr-svg-icon--arrow--right govgr-svg-icon"
                    focusable="false"
                    aria-hidden="true"> <path d="M8.5,2L6.1,4.3l7.6,7.7l-7.6,7.6L8.5,22l10-10L8.5,2z"/> 
                  </svg>
                </button>
              </router-link>
            <li> Αν θέλετε να ελέγξετε ένα συγκεκριμένο επίδομα, μπορείτε να επιλέξετε από τις παρακάτω επιλογές για περισσότερες πληροφορίες και να δείτε τα κριτήρια που ισχύουν:</li>
          </ol>
          <ExpandableSection class="govgr-mb-6"
            v-for="(benefit, index) in benefits"
            :key="index"
            :title="benefit.title"
            :briefDescription="benefit.briefDescription"
            :moreInformation="benefit.moreInformation"
            :link="benefit.link"
          />
        </section>
        <hr class="govgr-section-break govgr-section-break--visible"/>
        <section data-section="q-and-a">
          <h2 class="govgr-heading-l">Συχνές Ερωτήσεις</h2>
          <QuestionElement
            v-for="(question, index) in questions"
            :key="index"
            :question="question.prompt"
            :answer="question.answer"
          />
        </section>
      </main>
    </MainLayout>
  </div>
</template>

<script>
import ExpandableSection from '@/components/Elements/ExpandableSection.vue';
import QuestionElement from '@/components/Elements/QuestionElement.vue';
import MainLayout from '@/components/Elements/Layouts/MainLayout.vue';
import { benefitsInfo } from '@/info/benefitsInfo.js';
import { questionsInfo } from '@/info/questionsInfo.js';

export default {
  name: 'HomePage',
  components: {
    MainLayout,
    ExpandableSection,
    QuestionElement,
  },
  data() {
    return {
      benefits: benefitsInfo,
      questions: questionsInfo.filter(q => q.tag === "all").map(q => q),
      assessmentLink: '/OverallBenefits',
      showDisclaimerModal: false,
    };
  },
  methods: {
    closeModal() {
      this.showDisclaimerModal = false;
    },
  },
  watch: {
    showDisclaimerModal(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
section {
  margin: 4vw;
  text-align: left;
}

main {
  flex: 1;
}

.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.footer {
  align-self: end;
}

ol li {
  margin: 1vh;
}

.govgr-btn:hover .govgr-svg-icon--arrow--right {
  transform: translateX(6px);
  transition: transform 0.3s ease;
}

.govgr-svg-icon--arrow--right {
  transition: transform 0.3s ease;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 4px;
  max-width: 700px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
}

.modal-body {
  margin: 1.5rem 0;
  text-align: left;
}

.modal-body p {
  margin-bottom: 1rem;
  line-height: 1.6;
  font-size: 16px;
}

.modal-content button {
  margin-top: 1rem;
}

/* Modal Transitions */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active .modal-content,
.modal-leave-active .modal-content {
  transition: transform 0.3s ease;
}

.modal-enter-from .modal-content,
.modal-leave-to .modal-content {
  transform: scale(0.9);
}
</style>